import { APP_LINKS } from '../data/appLinks';
import { PageLink } from '../router';
import { AndroidIcon, AppleIcon } from './icons';
import './AppDownloadButtons.css';

/**
 * iOS leaves the site for TestFlight. Android stays on it: the closed test needs
 * a short walkthrough before the Play Store will offer the app.
 */
export const AppDownloadButtons = ({ inverse = false, className = '' }) => (
  <div
    className={`tl-download-actions${inverse ? ' tl-download-actions--inverse' : ''} ${className}`.trim()}
  >
    <a
      className="tl-button tl-button--primary"
      href={APP_LINKS.ios}
      target="_blank"
      rel="noopener noreferrer"
    >
      <AppleIcon />
      Get iOS
    </a>
    <PageLink className="tl-button tl-button--secondary" to={APP_LINKS.android}>
      <AndroidIcon />
      Get Android
    </PageLink>
  </div>
);
